import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import PackagingPurchaseOrderListView from 'src/sections/packaging-purchase-order/view/packaging-purchase-order-list-view';

export default function PackagingPurchaseOrderListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Packaging Purchase Orders</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_PACKAGING_PURCHASE_ORDER,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <PackagingPurchaseOrderListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
